import { StyleSheet } from 'react-native';
import { SIZES, PALETTE, MQ_TABLET,SEPARATOR_STROKE, SM_DEVICE} from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
const WINDOW_WIDTH = 1000;
const WINDOW_HEIGHT = 1000;

export default MediaQueryStyleSheet.create({
  root: {
    flex: 1,
    paddingVertical: 10,
  },
   
  wrap:{
    flex: 1,
  }, 
  textinfo:{
    color: PALETTE.secondaryText,
    width: WINDOW_WIDTH,
  },
  textCenter:{
    textAlign: 'center',
  },
  content: {
    flex: 1,
    paddingHorizontal: 22,
    marginTop: 20,
  },
  contentsucess:{
    flex: 1,
    paddingHorizontal: 22,
    marginTop: WINDOW_HEIGHT*0.3,
  },
  contactRow: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  upper:{
    flex: 0.67,
    flexDirection: 'row',
  },
  login: {
    flex: 1,
  },
  txt: {
    minHeight: 88,
    width:40,
    marginLeft:2,
  },
  txt1: {
    minHeight: 88,
    width:40,
    marginLeft:2,
    borderWidth:1,
    borderColor:'red',
  },
  username: {
    minHeight: 88,
  },
  password: {
    minHeight: 108,
  },
  label: {
    paddingTop: 10,
  },
  pushBottom: {
    paddingBottom: 15,
  },
  support: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
  },
  link: {
    flex: 1,
    flexWrap: 'nowrap',
  },
  separator: {
    borderRightWidth: 1,
    borderRightColor: SEPARATOR_STROKE,
    width: 0,
    height: 16,
  },
  footer: {
    flex: 0,
    paddingHorizontal: 29,
  },
  footerLinks: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  footerInfo: {
    flex: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  separatorWithSpacing: {
    borderRightWidth: 1,
    borderRightColor: SEPARATOR_STROKE,
    width: 0,
    height: 16,
    marginHorizontal: 15,
  },
  changePasswordSuccess: {
    marginVertical: 30,
  },
  validateToken:{
    marginTop: 20,
  },
  infoContainerText :{
  marginLeft : 15,
  },
  buttonview: {
   flex:0.2,
  },
  pinbuttonview:{
    flex:0.18,
  },

},{
  [MQ_TABLET]: {
    root:{
     width:WINDOW_WIDTH*0.6,
     alignSelf:'center',
     borderWidth: 2,
     borderColor: PALETTE.primaryStrokeLine,
     alignItems:'center',
     paddingTop:50,
    },
    content:{
      alignItems:'center',
    },
    validateToken:{
        width:WINDOW_WIDTH*0.38,   
    },
    buttonview:{ flex:0.3, },
    pinbuttonview:{
       flex:0.29,
    },
  },
  [SM_DEVICE]:{

  validateToken:{
    marginTop: 10,
  },
  content: { paddingHorizontal:10, marginTop: 2, },
  buttonview:{ flex:0.08, },
  
  pinbuttonview:{
       flex:0.076,
    },  

  }
});
